<template>
	<div class="tender-form">
		<div class="form">
			<div class="form__inputs form__inputs--3">
				<InputText v-model="formData.name" :label="type === 'TN' ? 'Наименование тендера' : 'Наименование запроса'" :placeholder="type === 'TN' ? 'Тендер на закупку свинины' : 'Запрос на закупку свинины'" :errors="v$.formData.name.$errors"/>
				<InputDate v-model="auctionStart" :label="'Дата/Время начала торгов'" :placeholder="'xx.xx.xxxx 00:00'" :mode="'dateTime'" :errors="v$.formData.auctionStart.$errors"/>
				<InputDate v-model="auctionEnd" :label="'Дата/Время окончания торгов'" :placeholder="'xx.xx.xxxx 00:00'" :mode="'dateTime'" :errors="v$.formData.auctionEnd.$errors"/>
				<template v-if="type === 'TN'" >
					<InputDate v-model="supplyTimeFrom" :label="'Срок поставки с'" :placeholder="'xx.xx.xxxx'"/>
					<InputDate v-model="supplyTimeTo" :label="'Срок поставки до'" :placeholder="'xx.xx.xxxx'"/>

					<InputText v-model="formData.priceStep" :label="'Шаг в цене (руб)'" :placeholder="'5 000'" :cost="true" :errors="v$.formData.priceStep.$errors"/>
					
					<InputSelect :label="'Способ доставки'" :errors="v$.formData.deliveries.$errors">
						<template #select>
							<Multiselect
								:can-clear="false"
								:canDeselect="false"
								:options="deliveries"
								:label="'name'"
								:value-prop="'id'"
								:mode="'tags'"
								v-model="formData.deliveries"
								:placeholder="'Выберите способ доставки'"
								:no-results-text="'Способы доставки не найдены'"
								:noOptionsText="'Не найдены'"
								/>
						</template>
					</InputSelect>

					<InputSelect v-if="deliveryDest?.length" :label="'Место доставки'" >
						<template #select>
							<Multiselect
								:can-clear="false"
								:canDeselect="false"
								:options="deliveryDest"
								:label="'name'"
								:value-prop="'id'"
								:mode="'tags'"
								v-model="formData.deliveryDestinations"
								:placeholder="'Выберите место доставки'"
								:no-results-text="'Места доставки не найдены'"
								:noOptionsText="'Не найдены'"
								/>
						</template>
					</InputSelect>
				</template>
				<InputSelect v-if="getGroupOrCenter('useShops') || type === 'CO'" :label="'Группа магазинов'">
						<template #select>
							<Multiselect
								:can-clear="false"
								:canDeselect="false"
								:options="shopGroups"
								:label="'name'"
								:value-prop="'id'"
								:mode="'tags'"
								v-model="formData.shopGroups"
								:placeholder="'Выберите группу магазинов'"
								:no-results-text="'Группы магазинов не найдены'"
								:noOptionsText="'Не найдены'"
								/>
						</template>
					</InputSelect>

					<InputSelect v-if="getGroupOrCenter('useDistrCenters') || type === 'CO'" :label="'Распределительный центр'">
						<template #select>
							<Multiselect
								:can-clear="false"
								:canDeselect="false"
								:options="distrCenter"
								:label="'name'"
								:value-prop="'id'"
								v-model="formData.distrCenter"
								:placeholder="'Выберите распределительный центр'"
								:no-results-text="'Распределительные центры не найдены'"
								/>
						</template>
					</InputSelect>
			</div>
		</div>
		<template v-if="type === 'TN'">
			<hr>
			<div class="tender-checkbox">
				<InputCheckbox label="Продлевать запрос" v-model="formData.addTime"/>
				<div class="tooltip">
					<span class="tooltip__icon"></span>
					<span class="tooltip__text">Если опция выбрана, то предложения, сделанные за 5 минут до окончания тендера, продлевают тендер на 5 минут</span>
				</div>
			</div>
		</template>
		<hr>
		<TenderTable ref="positions" v-model="formData.positions" :itsCO="this.type === 'CO'"/>
		<hr>
		<div class="detail-info">
			<div class="page-subtitle">Детальная информация о закупке</div>
			<InputTextarea v-model="formData.description"/>
		</div>
		<UploadDocs v-model="formData.documents"  :docsList="this.tender?.documents" dark/>
		<hr>
		<div class="page-content__btns">
			<div v-if="getUserRole !== 'administrator'" class="page-content__btns-right">
				<button class="btn btn--border" @click="sendForm">Сохранить</button>
				<button class="btn btn--color" v-if="tenderId" @click="ShowApproveTenderPopup = true">Утвердить</button>
			</div>
		</div>
		<PageLoader v-if="isLoading"/>
	</div>
	<transition name="modal">
		<ApproveTenderPopup v-if="ShowApproveTenderPopup" :tenderId="tenderId" :type="type" @close="ShowApproveTenderPopup = false"/>
	</transition>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import InputDate from "@/components/base/utils/formElements/InputDate.vue";
import InputTextarea from "@/components/base/utils/formElements/InputTextarea.vue";
import InputCheckbox from "@/components/base/utils/formElements/InputCheckbox.vue";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import TenderTable from "@/components/sections/Tenders/CreateEditTender/TenderTable.vue";
import ApproveTenderPopup from "@/components/sections/Tenders/CreateEditTender/ApproveTenderPopup.vue";
import UploadDocs from "@/components/base/utils/UploadDocs.vue";
import objectToFormData from "@/utils/ObjectToFormData";
import Fetch from "@/utils/Fetch";
import { useToast } from "vue-toastification";
import useVuelidate from "@vuelidate/core";
import {required, helpers} from '@vuelidate/validators'
const {withMessage} = helpers
import moment from 'moment';

export default {
	name: "TenderForm",
	emits: ['changeType'],
	components: {
		InputText,
		InputDate,
		InputSelect,
		InputCheckbox,
		Multiselect,
		TenderTable,
		UploadDocs,
		InputTextarea,
		ApproveTenderPopup,
		PageLoader
	},
	props: {
		type : {
			type: String,
			default: 'TN'
		},
		deliveries: {
			type: Array,
			default: () => []
		},
		shopGroups: {
			type: Array,
			default: () => []
		},
		deliveryDestinations: {
			type: Array,
			default: () => []
		},
		productGroups: {
			type: Array,
			default: () => []
		},
		distrCenter: {
			type: Array,
			default: () => []
		},
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			moment: moment,
			isLoading: false,
			tender: null,
			formData: {
				name: '',
				auctionStart: '',
				auctionEnd: '',
				priceStep: '',
				supplyTimeFrom: '',
				supplyTimeTo: '',
				deliveries: [],
				deliveryDestinations: [],
				distrCenter: [],
				shopGroups: [],
				positions: [],
				documents: [],
				description: '',
				addTime: false
			},
			auctionStart: [''],
			auctionEnd: [''],
			supplyTimeFrom: [''],
			supplyTimeTo: [''],
			tenderId: null,
			ShowApproveTenderPopup: false
		}
	},
	async mounted() {
		const params = (new URL(document.location)).searchParams;
		const id = params.get("ID");
		if(id) {
			await this.loadTenderInfo(id);
		} else {
			this.fillDateAuction()
		}
	},

	computed: {
		deliveryDest() {
			if(this.formData.deliveries.length > 1) {
				const deliveryWithMostDestinations = this.deliveries.reduce((acc, curr) => {
						if (curr.deliveryDestinations.length > acc.deliveryDestinations.length) {
							return curr;
						} else {
							return acc;
						}
					}, this.deliveries[0]);
				return deliveryWithMostDestinations.deliveryDestinations
			}
			return this.deliveries.find(option => option.id === this.formData.deliveries[0])?.deliveryDestinations
		},
		getGroupOrCenter() {
			return (arg) => {
				if(this.formData.deliveryDestinations.length >= 2) return true
				return this.deliveryDestinations.find(option => option.id === this.formData.deliveryDestinations[0])?.[arg]
			}
		},
		...mapGetters({
			getUserRole: 'user/getUserRole',
		})
	},
    watch: {
		'formData.deliveries'() {
			this.formData.deliveryDestinations = []
			this.formData.distrCenter = []
			this.formData.shopGroups = []
		},
		'formData.deliveryDestinations'() {
			this.formData.distrCenter = []
			this.formData.shopGroups = []
		},

		auctionStart: {
			handler(newValue) {
				this.formData.auctionStart = this.getLocaleDateAndTime(newValue[0]);
			},
			deep: true
		},
		auctionEnd: {
			handler(newValue) {
				this.formData.auctionEnd = this.getLocaleDateAndTime(newValue[0]);
			},
			deep: true
		},
		supplyTimeFrom: {
			handler(newValue) {
				this.formData.supplyTimeFrom = this.getLocaleDateAndTime(newValue[0], false);
			},
			deep: true
		},
		supplyTimeTo: {
			handler(newValue) {
				this.formData.supplyTimeTo = this.getLocaleDateAndTime(newValue[0], false);
			},
			deep: true
		},
	},
	methods: {
		getLocaleDateAndTime(value,needTime = true) {
			const date = new Date(value).toLocaleDateString();
			const time = needTime ? new Date(value).toLocaleTimeString().slice(0,5) : '';
			if(time) {
				return `${date} ${time}`
			}
			return date
		},

		async sendForm() {
			this.isLoading = true

			const validated = await this.v$.formData.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				this.isLoading = false
				return
			}
			this.$refs.positions.updatePositions();

			const formatedPositions = this.formData.positions
			for (let i = 0; i < formatedPositions.length; i++) {
				if(this.type === 'CO') {
					formatedPositions[i].startPrice = null
				} else if(typeof formatedPositions[i].startPrice === 'string') {
					formatedPositions[i].startPrice = formatedPositions[i].startPrice?.replace(/ /g, '');
				}
				formatedPositions[i].lotSize = formatedPositions[i].lotSize?.replace(/ /g, '');

				if(formatedPositions[i].supplyTimeFrom[0] !== '') {
					formatedPositions[i].supplyTimeFrom = this.getLocaleDateAndTime(formatedPositions[i].supplyTimeFrom[0],false)
				}
				if(formatedPositions[i].supplyTimeTo[0] !== '') {
					formatedPositions[i].supplyTimeTo = this.getLocaleDateAndTime(formatedPositions[i].supplyTimeTo[0], false)
				}
			}

			const body = objectToFormData({
				id: this.tenderId,
				type: this.type,
				name: this.formData.name,
				addTime: this.formData.addTime,
				auctionStart: this.formData.auctionStart,
				auctionEnd: this.formData.auctionEnd,
				supplyTimeFrom: this.formData.supplyTimeFrom != 'Invalid Date' ? this.formData.supplyTimeFrom : null,
				supplyTimeTo: this.formData.supplyTimeTo != 'Invalid Date' ? this.formData.supplyTimeTo : null,
				priceStep: this.formData.priceStep.replace(/ /g,''),
				distrCenter: this.formData.distrCenter,
				deliveries: this.type === 'TN' ?  this.formData.deliveries : null,
				deliveryDestinations: this.type === 'TN' ?  this.formData.deliveryDestinations : null,
				shopGroups: this.formData.shopGroups,
				positions: formatedPositions,
				documents: this.formData.documents,
				description: this.formData.description,
			})
			
			let response = await Fetch(this.tenderId ? 'tenders/update/' : 'tenders/add/', {
				method: 'POST',
				body
			})

			if(response.success) {
				const typeString = this.type === 'TN' ? 'Тендер' : 'Запрос'
				this.toast.success(this.tenderId ? `${typeString} успешно изменен` : `${typeString} успешно добавлен`);

				this.tenderId = response.data
			} else {
				this.toast.error(response.message);
			}
			this.isLoading = false
		},

        async loadTenderInfo(id = this.tender.id) {
			this.isLoading = true
			const res = await this.requestTenderItem(id);
			if (res.success) {
				this.tender = res.data;
				this.fillFormData()
			}
		},

		fillFormData() {
			this.formData.addTime = this.tender.addTime
			this.tenderId = this.tender.id
			this.formData.name = this.tender.name
			this.auctionStart = [moment(this.tender.auctionStart, "DD.MM.YYYY HH:mm").toDate()]
			this.auctionEnd = [moment(this.tender.auctionEnd, "DD.MM.YYYY HH:mm").toDate()]
			this.supplyTimeFrom = [moment(this.tender.supplyTimeFrom, "DD.MM.YYYY").toDate()]
			this.supplyTimeTo = [moment(this.tender.supplyTimeTo, "DD.MM.YYYY").toDate()]
			this.formData.priceStep = `${this.tender.priceStep || ''}`
			this.formData.description  = this.tender.description
			this.formData.documents  = this.tender.documents

			if(this.tender.type.code === 'CO') {
				this.$emit('changeType')
			} else {
				this.formData.deliveries = this.fillSelect(this.tender.deliveries)
				setTimeout(() => this.formData.deliveryDestinations = this.fillSelect(this.tender.deliveryDestinations), 100)
			}

			setTimeout(() => {
				this.formData.shopGroups = this.fillSelect(this.tender.shopGroups)
				this.formData.distrCenter = this.tender.distrCenter?.id
			}, 300)


			this.$refs.positions.fillPositions(this.tender.positions);

			this.isLoading = false
		},

		fillSelect(array) {
			const selectedArray = []
			array?.forEach(item => selectedArray.push(item.id))
			return selectedArray
		},

		fillDateAuction() {
			const date = new Date();
			
			this.auctionStart[0] = date.setHours(8, 0)
			this.auctionEnd[0] = date.setHours(17, 0)
		},

        ...mapActions({
            requestTenderItem: 'tenders/requestTenderItem',
		}),
	},
	validations() {
		return {
			formData: {
				name: {
					required: withMessage("Заполните наименование", required),
				},
				auctionStart: {
					required: withMessage("Заполните время начала торгов", required),
				},
				auctionEnd: {
					required: withMessage('Заполните время окончания торгов', required),
				},

				priceStep: {
					required: this.type === 'TN' ? withMessage('Заполните шаг в цене', required) : true,
				},
				deliveries: {
					required: this.type === 'TN' ? withMessage('Выберите способ доставки', required) : true,
				},
			}
		}
	},
}
</script>
